import React__default, { useContext } from 'react';
import { jsx } from '@emotion/react';

var EditorInfoContext = /*#__PURE__*/React__default.createContext({
  uploadEndpoint: '',
  isInitialLoadAllContent: false
});
var useEditorInfoContext = function useEditorInfoContext() {
  return useContext(EditorInfoContext);
};

/** 외부에서 주입하는 context 중 여러 Inspector에서 사용되는 context를 관리합니다. */
function EditorInfoContextProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return jsx(EditorInfoContext.Provider, {
    value: value
  }, children);
}

export { EditorInfoContextProvider, useEditorInfoContext };
//# sourceMappingURL=EditorInfoContext.js.map
